<template>
    <div>
        <div class="nav-tabs-container pt-1">
            <div class="nav-tabs-scroll-helper">
                <ul class="nav nav-tabs">

                    <li class="nav-item">
                        <a class="nav-link" :class="{'active': mode == 'all'}" href id="tabLinkPaygroups1" role="tab" aria-controls="tabContentPaygroups1" :aria-selected="mode == 'all'" @click.prevent="mode = 'all'; $bus.$emit('resize')">
                            All Pay Groups ({{ allPaygroupsCount }})
                        </a>
                    </li>

                    <li class="nav-item">
                        <a class="nav-link" :class="{'active': mode == 'selected'}" href id="tabLinkPaygroups2" role="tab" aria-controls="tabContentPaygroups1" :aria-selected="mode == 'selected'" @click.prevent="mode = 'selected'; $bus.$emit('resize')">
                            Selected ({{ selectedPaygroupsCount }})
                        </a>
                    </li>

                </ul>
            </div>
        </div>

        <div class="flex-body flex-container tab-content paygroup-selector">
            <div class="flex-body flex-container tab-pane" :class="{'show active': mode == 'all'}" id="tabContentPaygroups1" role="tabpanel" aria-labelledby="tabLinkPaygroups1">
                <fast-table
                    v-if="mode == 'all'"
                    :sections="paygroupSections"
                    :headers="paygroupHeaders"
                    :data="paygroupTableData"
                    @click="onPaygroupClick"
                    @select="onPaygroupSelect"
                    :has-row-select="true"
                    :show-filter="false"
                    :show-more-actions="false"
                />

            </div>

            <div class="flex-body flex-container tab-pane" :class="{'show active': mode == 'selected'}" id="tabContentPaygroups2" role="tabpanel" aria-labelledby="tabLinkPaygroups2">
                <fast-table
                    v-if="mode == 'selected'"
                    :sections="paygroupSections"
                    :headers="paygroupHeaders"
                    :data="selectedPaygroupTableData"
                    @click="onPaygroupClick"
                    @select="onPaygroupSelect"
                    :has-row-select="true"
                    :show-filter="false"
                    :show-more-actions="false"
                />

            </div>
        </div>
    </div>
    </template>

    <script>
    import FastTable from '@/components/FastTable'

    export default {
        props: ['modelValue', 'client', 'selectablePaygroups'],
        emits: ['update:modelValue'],
        components: {FastTable, },
        computed: {
            paygroupTableData() {
                const result = []

                this.paygroups.forEach(p => {
                    const company = this.client.companies.find(c => c.id == p.company_id)
                    result.push({
                        id: p.id,
                        isSelected: this.formData.paygroups.includes(p.id),
                        object: p,
                        cells: [
                            p.name,
                            company.name,
                        ],
                    })
                })

                return [result]
            },
            selectedPaygroupTableData() {
                let result = this.paygroupTableData[0].filter(row => {
                    return this.formData.paygroups.includes(row.object.id)
                })

                result = JSON.parse(JSON.stringify(result))
                result.forEach(row => {
                    row.isSelected = true
                })

                return [result]
            },
            allPaygroupsCount() {
                return this.paygroupTableData[0].length
            },
            selectedPaygroupsCount() {
                return this.selectedPaygroupTableData[0].length
            },
        },
        data() {
            return {
                mode: 'all',
                paygroups: this.selectablePaygroups || [],
                formData: {
                    paygroups: Array.from(this.modelValue),
                },
                paygroupSections: [
                    {title: 'All', id: 'all'},
                ],
                paygroupHeaders: [
                    {label: 'Pay Group', classes: '', defaultSort: true, isFilterable: false, isSearchable: true, },
                    {label: 'Company', classes: '', isFilterable: true, isSearchable: true, },
                ],
            }
        },
        mounted() {
            this.$bus.$emit('resize')
            if (!this.selectablePaygroups) {
                this.getPaygroups()
            }
        },
        methods: {
            getPaygroups() {
                this.$store.dispatch('START_LOADING')
                this.$api.get(`/clients/${this.client.id}/settings/paygroups`).then(resp => {
                    this.paygroups = resp
                    this.$store.dispatch('STOP_LOADING')
                }).catch((errors) => {
                    this.$store.dispatch('STOP_LOADING')
                    if (errors.__status__ == 403) {
                        this.$bus.$emit('no-access')
                    }
                    else {
                        this.$bus.showError(errors.__all__)
                    }
                })
            },
            onPaygroupSelect(rows) {
                const paygroups = new Set()
                rows.forEach(row => {
                    paygroups.add(row.object.id)
                })

                this.formData.paygroups = Array.from(paygroups)
                // TODO KB PG add logic to grey out paygroups that cannot be combined into collection with selection

                this.$emit('update:modelValue', this.formData.paygroups)
            },
            onPaygroupClick(paygroup) {
                if (this.formData.paygroups.includes(paygroup.id)) {
                    this.formData.paygroups = this.formData.paygroups.filter(cId => cId != paygroup.id)
                }
                else {
                    this.formData.paygroups.push(paygroup.id)
                }

                this.$emit('update:modelValue', this.formData.paygroups)
            },
        },
    }

    </script>

    <style>
    .paygroup-selector .table-wrapper {
        min-height: 300px;
    }
    </style>
